// extracted by mini-css-extract-plugin
export default {"brand":"styles_brand__tBUPv","main_section":"styles_main_section__AeaBD","left_banner":"styles_left_banner__lgSXw","right_section":"styles_right_section__isScF"};